export default __webpack_public_path__ + "221154c45afd6c25366b854e6b3bd811.png";